import contract, {selectors} from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import redirect from '#utilities/js/hotkey/redirect.js'

export default contract({
    [selectors]: {
        'slot[data-name="hotkey-new"]': array([
            redirect
        ]),
    }
})